// @ts-nocheck
import { TRADE_ACTIVITY } from "../data/tradeActivity";

const slugify = (value) => {
  if (!value) return "unknown";
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 64);
};

const hashString = (value) => {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

const seededRandom = (seed) => {
  let value = seed % 2147483647;
  if (value <= 0) value += 2147483646;
  return () => {
    value = (value * 16807) % 2147483647;
    return (value - 1) / 2147483646;
  };
};

export const buildCardId = (cardName, game) => {
  return `${slugify(cardName)}-${slugify(game)}`;
};

export const getMarketAnalytics = (cardName, game) => {
  const seed = hashString(`${cardName}-${game}`);
  const rand = seededRandom(seed);
  const base = 12 + (seed % 180);
  const variance = 8 + (seed % 40);
  const low = Math.max(4, Math.round(base - variance));
  const high = Math.max(low + 4, Math.round(base + variance));
  const trendIndex = seed % 3;
  const trend = trendIndex === 0 ? "up" : trendIndex === 1 ? "down" : "flat";
  const seriesLength = 48;
  const series = Array.from({ length: seriesLength }, (_, idx) => {
    const noise = rand() * 6 - 3;
    const drift = trend === "up" ? idx * 0.15 : trend === "down" ? idx * -0.12 : 0;
    return Math.max(2, base + noise + drift);
  });

  return { low, high, trend, series };
};

export const getTrendSymbol = (trend) => {
  if (trend === "up") return "↑";
  if (trend === "down") return "↓";
  return "→";
};

export const getMarketHint = (cardName, game) => {
  const { low, high, trend } = getMarketAnalytics(cardName, game);
  return `Market: $${low}-${high} • ${getTrendSymbol(trend)}`;
};

export const buildCardDetailUrl = (cardId, cardName, game) => {
  const params = new URLSearchParams();
  if (cardName) params.set("name", cardName);
  if (game) params.set("game", game);
  const query = params.toString();
  return `/card/${cardId}${query ? `?${query}` : ""}`;
};

export const getTradeActivityForCard = (cardId) => {
  return TRADE_ACTIVITY.filter((item) => item.cardId === cardId);
};

export const formatRelativeTime = (isoString) => {
  if (!isoString) return "";
  const now = Date.now();
  const time = new Date(isoString).getTime();
  const diffMs = Math.max(0, now - time);
  const minute = 60000;
  const hour = 60 * minute;
  const day = 24 * hour;
  const week = 7 * day;

  if (diffMs < hour) {
    const mins = Math.max(1, Math.round(diffMs / minute));
    return `${mins} min ago`;
  }
  if (diffMs < day) {
    const hours = Math.round(diffMs / hour);
    return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  }
  if (diffMs < week) {
    const days = Math.round(diffMs / day);
    return `${days} day${days === 1 ? "" : "s"} ago`;
  }
  const weeks = Math.round(diffMs / week);
  return `${weeks} week${weeks === 1 ? "" : "s"} ago`;
};
